module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sprague L. de Camp, Lin Carter, Björn Nyberg\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("L. Sprague de Camp")]), _vm._v(", a SFWA Grand Master and winner of the World Fantasy Award for Life Achievement, wrote the definitive biography of Conan's creator, Robert E. Howard. De Camp died in 2000."), _c('br'), _c('br'), _c('B', [_vm._v("Lin Carter ")]), _vm._v("was the key figure behind the popular Ballantine Adult Fantasy Series of the 1970s. He died in 1988."), _c('br'), _c('br'), _c('B', [_vm._v("Björn")]), _vm._v(" Nyberg"), _vm._v(" first began collaborating with de Camp on Conan works in the 1950s. He lives in France.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/f0YBed/tc-custom/9781466834972.jpg?1738812122523",
      "alt": "This image is the cover for the book Conan the Swordsman"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Conan the Swordsman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The iconic hero of the Hyborian Age returns in this volume of classic fantasy adventure stories.")])]), _c('p', [_vm._v("Sometime after the fall of Atlantis, a great hero was born on a battlefield, destined to defend his people against angry gods and merciless demons. His name was Conan, and his exploits are legend.")]), _c('p', [_vm._v("This volume collects eight classic Conan stories and an essay on the work of Conan creator Robert E. Howard. These stories from renowned fantasy author L. Sprague de Camp, and co-written with Lin Carter and Bjorn Nyberg, relaunched Conan as a popular hero in the 1970s. They include “The Conan Saga”, “Legions of the Dead”, “The People of the Summit”, and others.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    A Tom Doherty Associates Book\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0